import Layout from "@/layout";
export default {
    meta: {
        title: "设置",
        icon: "ali_zggl",
    },
    path: "/setting",
    component: Layout,
    children: [
        {
            path: "/setting/category",
            name: "settingCategory",
            component: () => import("@/views/setting/category"),
            meta: {
                title: "分部分项",
                auth: [],
                img: "fbfx",
            },
        },
        {
            path: "/setting/settle",
            name: "settingSettle",
            component: () => import("@/views/setting/settle"),
            meta: {
                title: "结算单管理",
                auth: [],
                img: "fbfx",
            },
        },
        {
            path: "/ZgConfig/index",
            name: "ZgConfig",
            component: () => import("@/views/ZgConfig/index"),
            meta: {
                title: "整改形式设置",
                auth: [],
                img: "pf",
            },
        },
        {
            path: "/RecordSetting/index",
            name: "RecordSetting",
            component: () => import("@/views/RecordSetting/index"),
            meta: {
                title: "执法记录设置",
                auth: [],
                img: "pf",
            },
        },
    ],
};
